module.exports = __webpack_public_path__ + "img/bannerProspects.0db7d9f8.jpg";